export const labels_en = {
  applicationNameLong: "Knowledge Management",
  applicationNameShort: "KM",
  username: "Username",
  password: "Password",
  passwordPlaceholder: "Enter password",
  confirmPassword: "Confirm password",
  login: "Login",
  needAccount: "Need an account?",
  register: "Register",
  registration: "Registration",
  logout: "Logout",
  home: "Home",
  all: "All",
  search: "Search",
  name: "Name",
  namePlaceholder: "Enter name",
  uriPlaceholder: "Enter URI",
  institutionPlaceholder: "Enter institution",
  id: "ID",
  description: "Description",
  descriptionPlaceholder: "Enter description",
  closeButton: "Close",
  saveButton: "Save",
  comments: "Comments",
  commentBox: "Write a message...",
  comment: "Comment",
  fullName: "Name and Surname",
  previous: "Previous",
  next: "Next",
  submit: "Submit",
  cancel: "Cancel",
  pageNotFound: "Page not found",
  welcome: "Welcome",
  administration: "Administration",
  knowledgeManagement: "Knowledge management",
  classification: "Business classification",
  adminClassification: "Business classification administration",
  classificationType: "Business classification type",
  classificationStatus: "Business classification status",
  addButton: " Add",
  deleteButton: " Delete",
  deleteButtonDescription: "Delete checked rows",
  code: "Code",
  codePlaceholder: "Entry code",
  dateFrom: "Date from",
  dateFromPlaceholder: "Entry date from",
  dateTo: "Date to",
  dateFromTo: "Date (from-to)",
  dateToPlaceholder: "Entry date to",
  statusPlaceholder: "Choose status",
  typePlaceholder: "Choose type",
  generalData: "General data",
  noData: "No data",
  descriptionUsage: "Description usage",
  saved: "Saved",
  deleted: "Deleted",
  knowledgeType: "Knowledge type",
  knowledgeCopyright: "Copyright",
  knowledgeItem: "Knowledge item",
  knowledgeSource: "Knowledge source",
  state: "State",
  states: "States",
  knowledgeSourceClassification: "Knowledge source classification",
  lifeCycle: "Life cycle",
  lifeCycleStateType: "Life cycle state type",
  lifeCycleChangedBy: "Life cycle set by",
  changedBy: "Set by",
  recordedBy: "Recorded by",
  modifiedBy: "Last updated by",
  partyInformation: "Party information",
  note: "Note",
  uri: "URI",
  tags: "Tags",
  tag: "Tag",
  expand: "Expand",
  selectedClassifications: "Selected business classifications",
  chooseClassification: "Choose business classification",
  additionalData: "Additional data",
  documents: "Documents",
  documentsUpdate: "Document info update",
  contentType: "Content type",
  dateCreated: "Creation date",
  areYouSureDelete: "Are you sure you want to delete this document?",
  no: "No",
  yes: "Yes",
  actions: "Actions",
  upload: "Upload",
  selectFiles: "Select files",
  selectedFilesNum: "file(s)",
  knowledge: "Knowledge",
  previousLifeCycle: "Previous state",
  currentLifeCycle: "Current state",
  date: "Date",
  ratings: "ratings",
  rateNow: "Rate now",
  myRating: "My rating",
  institution: "Institution",
  messageLog: "Messages",
  message: "Message",
  details: "Details",
  selectedKnowledgeSource: "Selected knowledge source",
  lifeCycleClassDefinitions: "Life cycle class definitions",
  lifeCycleClassDefinition: "Life cycle class definition",
  possibleNextStates: "Possible next states",
  selectedNextStates: "Selected next states",
  lifeCycleTransitions: "State transitions",
  messageLogType: "Message type",
  partyRoles: "Party roles",
  roleTypes: "Role types",
  partyRoleTypeDiscriminatorPlaceholder: "Choose discriminator",
  roleType: "Role type",
  involvementRoleTypePlaceholder: "Select involvement role type",
  extensions: "Extensions",
  individuals: "Individuals",
  firstName: "First name",
  lastName: "Family name",
  email: "E-mail",
  individual: "Individual",
  roleTypeName: "Role type name",
  partyRole: "Party role",
  roleTypePlaceholder: "Choose role type",
  involvementRole: "Involvement Role",
  involvementRoleTypes: "Involvement Role Types",
  involvementRoleType: "Involvement Role Type",
  partyRoleTypeDiscriminator: "Discriminator",
  sendMessage: "Send",
  advancedSearchPlaceholder: "Enter words",
  advancedSearch: " Advanced search",
  correctWords: "Correct words",
  anyWords: "Any of those words",
  nonWords: "Non of those words",
  phrases: "Phrases",
  resetAdvancedSearchParams: "Reset",
  advancedSearchDescription: "Separate words with a comma",
  isAlreadySelected: "is already selected",
  isAdded: "is added",
  isRemoved: "is removed",
  status: "Status",
  type: "Type",
  parent: "Parent",
  parentPlaceholder: "Choose parent",
  active: "Active",
  inactive: "Inactive",
  advancedSearchParamsDelete: "Delete advanced search parameteres",
  classificationDetail: "Business classification details",
  parentInvolvementRoleTypes: "Inherited Involvement Role Types",
  atTime: ", at time: ",
  rating: "Rating",
  backButton: "Back",
  newTab: "Open in new tab",
  reactivateItem: "Reactivate",
  operations: "Operations",
  involvementRoles: "Involvement Roles",
  partiesAndSecurity: "Parties and Security",
  entities: "Entities",
  deleteItem: "Delete item",
  settings: "Settings",
  language: "Language",
  documentsContent: "Documents content",
  searchQueryPlaceholder: "Enter search query",
  searchResultHeader: "Search results",
  mostPopularTags: "Most Popular Tags",
  myContribution: "My Contribution",
  mostPopularClassifications: "Most Popular Business classifications",
  quickCreate: "Quick create",
  documentEntryForm: "Document entry form",
  uploadClickDragPlaceholder: "Click or drag file to this area to add",
  file: "File",
  document: "Document",
  KnowledgeItemCreate: "Entry knowledge item",
  system: "System",
  searchSettings: "ES Search Settings",
  startIndexing: "Start indexing",
  startIndexingTooltip: "Start Elastic Search indexing",
  ok: "OK",
  startIndexingModalBody:
    "ES indexing will temporarily disable ES search. Are you shure you want to start indexing?",
  startIndexingModalHeader: "Starting ES indexing",
  startIndexingAlert: "Indexing has been started",
  indexingStatus: "Indexing status",
  subscriptions: "Subscriptions",
  notifications: "Notifications",
  application: "Application",
  webBrowser: "Web-browser",
  classificationSubscriptions: "Business classification subscriptions",
  classificationNotifications: "Business classification notifications",
  partyMessageDetailTitle: "Notification",
  read: "Read",
  title: "Title",
  content: "Content",
  dispatchDate: "Dispatching date",
  partyMessagesTitle: "Notifications",
  entityLink: "Link to knowledge item",
  markAsRead: "Mark as read",
  markAsUnread: "Mark as unread",
  entityRelationshipTypes: "Entity relationship types",
  entityRelationshipType: "Entity relationship type",
  relationCardinalityType: "Relation type",
  notificationBadgeMessage: "Unread messages",
  allMessages: "All messages",
  entityRelationshipRelated: "Related entities",
  open: "Open",
  entityRelationShip: "Entity relationship",
  entity: "Entity",
  relatedEntity: "Related entity",
  unreadMessages: "Unread messages",
  chooseEntityPlaceholder: "Choose entity",
  reindexAllTitle: "Reindexing all entitites",
  reindexOneTitle: "Reindexing the selected entity",
  numberOfRatings: "Number of ratings: ",
  myRate: "My rating",
  searchable: "Searchable",
  deactivate: "Deactivate",
  edit: "Edit",
  urlCopied: "Url copied to clipboard.",
  shareViaMailSubject: "Look at this link",
  similarKnowledgeItem: "Similar knowledge item",
  moreLabel: "More...",
  information: "Information",
  help: "Help",
  reportToC2S2: "Report a bug to C2S2",
  refreshPage: "Refresh page",
  backToHome: "Back to home page",
  mostPopularKnowledgeItems: "Most popular knowledge items",
  withAttachment: "File content",
  chooseKnowledgeType: "Choose a knowledge type",
  chooseClassificationTypePlaceholder: "Choose a business classification type",
  classificationTypes: "Business classification types",
  chooseKnowledgeSource: "Choose a knowledge source",
  applicationCekom: "CIP4SI",
  initializing: "Initializing",
  loading: "Loading",
  autoTags: "Auto tags",
  addTag: "Add a tag",
  addToTag: "Add to tags",
  removeFromTags: "Remove from tags",
  shareWithMail: "Send link with email",
  shareWithWhatsApp: "Send link with WhatsApp",
  shareWithViber: "Send link with Viber",
  copyLink: "Copy link",
  similarKnowledgeItems: "Similar knowledge items",
  addToRelationship: "Add entity to relationship",
  showSimilarDocuments: "Show similar documents",
  similarDocuments: "Similar documents",
  recommended: "Recommended",
  organisations: "Groups",
  documentType: "Document type",
  documentTypeLink: "Link",
  documentTypeFile: "File",
  documentLinkPreview: "Preview URL",
  documentLinkDownload: "Download URL",
  documentLinkDuration: "Duration (s)",
  documentLinkSize: "Size (B)"
};
